import { cva, type VariantProps } from "class-variance-authority";
import type * as React from "react";

import { cn } from "@/lib/utils";

const cardVariants = cva(
	"group/card relative border text-card-foreground transition-[border-color,background-color] duration-200",
	{
		variants: {
			variant: {
				default:
					"border-rule-2 bg-paper-2/60 hover:border-ink-3 focus-within:border-ink-3",
				light: "border-rule-2 bg-paper-2 hover:border-ink-3",
			},
		},
		defaultVariants: {
			variant: "default",
		},
	},
);

const CardPin = () => (
	<span
		className="pointer-events-none absolute top-3 right-3 font-mono text-[0.7rem] text-ink-3 opacity-0 transition-opacity duration-200 group-hover/card:opacity-100 group-focus-within/card:opacity-100"
		aria-hidden="true"
	>
		&gt;
	</span>
);

function Card({
	className,
	variant = "default",
	showPin = true,
	children,
	...props
}: React.ComponentProps<"div"> &
	VariantProps<typeof cardVariants> & { showPin?: boolean }) {
	return (
		<div
			data-slot="card"
			data-variant={variant}
			className={cn(cardVariants({ variant }), className)}
			{...props}
		>
			{showPin ? <CardPin /> : null}
			{children}
		</div>
	);
}

export { Card, cardVariants };
